import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  DialogActions,
  DialogContent,
  LinearProgress,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import Intestazione from './Intestazione';
import useStili from './stili';

// What the check covers.
const CONTROLLI = [
  'File leggibile e versione dello schema riconosciuta',
  'Riferimenti interni coerenti',
  'Categorie e cadenze nel catalogo',
  'Controllo dei contenuti',
];

const useStyles = makeStyles((theme) => ({
  file: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
  datiFile: {
    flexGrow: 1,
    minWidth: 0,
  },
  nomeFile: {
    fontWeight: theme.typography.fontWeightMedium,
    overflowWrap: 'anywhere',
  },
  barra: {
    marginTop: theme.spacing(1.5),
    height: theme.spacing(0.75),
    borderRadius: theme.shape.borderRadius,
  },
  stato: {
    marginTop: theme.spacing(0.75),
    color: theme.palette.text.secondary,
  },
  titoloElenco: {
    marginTop: theme.spacing(3),
    fontWeight: theme.typography.fontWeightMedium,
  },
  elenco: {
    margin: theme.spacing(1, 0, 0),
    paddingLeft: theme.spacing(2.5),
    color: theme.palette.text.secondary,
    '& > li + li': {
      marginTop: theme.spacing(0.5),
    },
  },
}));

/**
 * The file is being checked: which file, and what the check looks at. The check does not report how far it got, so the bar runs indeterminate
 * and the list says what is checked, not which control is running.
 */
const VerificaInCorso = ({ file, onAnnulla }) => {
  const stili = useStili();
  const classes = useStyles();

  return (
    <>
      <DialogContent className={stili.content}>
        <Intestazione
          titolo="Verifica del file"
          testo="Il file viene controllato prima di toccare la Gestione Operativa."
        />
        <div className={`${stili.riquadro} ${classes.file}`}>
          <div className={`${stili.icona} ${stili.iconaFile}`}>
            <DescriptionOutlinedIcon aria-hidden="true" />
          </div>
          <div className={classes.datiFile}>
            <Typography variant="body2" className={classes.nomeFile}>
              {file.name}
            </Typography>
            <LinearProgress
              className={classes.barra}
              aria-label="Verifica del file in corso"
            />
            <Typography
              variant="caption"
              component="p"
              className={classes.stato}
            >
              Verifica in corso…
            </Typography>
          </div>
        </div>
        <Typography
          variant="body2"
          component="h3"
          className={classes.titoloElenco}
        >
          Cosa viene verificato
        </Typography>
        <Typography variant="body2" component="ul" className={classes.elenco}>
          {CONTROLLI.map((controllo) => (
            <li key={controllo}>{controllo}</li>
          ))}
        </Typography>
        <Typography variant="body2" className={stili.nota}>
          Finché la verifica non è conclusa nulla viene scritto: la Gestione
          Operativa viene aggiornata solo dopo, tutta insieme.
        </Typography>
      </DialogContent>
      <DialogActions disableSpacing className={stili.actions}>
        <Button
          variant="outlined"
          className={stili.secondario}
          onClick={onAnnulla}
        >
          Annulla
        </Button>
      </DialogActions>
    </>
  );
};

VerificaInCorso.propTypes = {
  file: PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired,
  onAnnulla: PropTypes.func.isRequired,
};

export default VerificaInCorso;
